// extracted by mini-css-extract-plugin
export default {"modal":"modal__1cf192","modalFooter":"modalFooter__1b19f0"};